import { measurementInMetric } from './get-metric-data';
export const profileInformation = () => {
  const metricMeasurement = measurementInMetric();

  return {
    age: metricMeasurement.age,
    weight_kg: metricMeasurement.weight,
  };
};

window.profileInformation = profileInformation;
